import { render, staticRenderFns } from "./DataListJourneys.vue?vue&type=template&id=7e130d30&scoped=true&"
import script from "./DataListJourneys.vue?vue&type=script&lang=js&"
export * from "./DataListJourneys.vue?vue&type=script&lang=js&"
import style0 from "./DataListJourneys.vue?vue&type=style&index=0&id=7e130d30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e130d30",
  null
  
)

export default component.exports